import React from "react";
import successCheckMark from "../../assets/images/successNewIcon.svg";
import { NewModal } from "../uiMerge/newModal";
import NewButton from "../uiMerge/newButton";

interface SuccessModalProps {
    visible: boolean;
    onCancel: () => void;
    caption: string;
    buttonCaption?: string;
    onClick: () => void;
    closeButtonCaption?: string;
    position?: "center" | "end" | "start";
}

export const SuccessModal: React.FC<SuccessModalProps> = (props) => {
    const { visible, onCancel, caption, buttonCaption, onClick, closeButtonCaption, position = "end" } = props;
    return (
        <NewModal isOpen={visible} heightClass="h-[351px]" showCloseButton={false} position={position} animationClass="grow-in" colorClass="bg-black" onClose={onCancel}>
            <div className='w-full flex flex-col justify-center items-center py-6 px-[1rem]'>
                <div className=' w-full flex flex-col justify-center gap-2 items-center'>
                    <div>
                        <img
                            src={successCheckMark}
                            alt='Reset Successful'
                            width={89}
                            height={89} />
                    </div>
                    <div className="w-[257px]">
                        <div>
                            <h2 className={"text-[24px] w-full text-center text-white font-bold mt-5 mb-1"}>
                                {"Success!"}
                            </h2>
                        </div>
                        <div className="text-[#CECECF] text-center text-[16px] mb-6">
                            <p>{caption || "This action was completed successfully."}</p>
                        </div>
                    </div>

                    <div className="flex gap-4 w-full">
                        <NewButton

                            fullWidth
                            variant='primary'
                            className={closeButtonCaption ? "!px-2 !text-sm" : undefined}
                            onClick={onClick}>
                            {buttonCaption || "Done"}
                        </NewButton>

                        {closeButtonCaption && (
                            <NewButton
                                fullWidth
                                variant='tertiary'
                                className="!px-2 !text-sm !bg-[#3C3E58] !border-[#3C3E58]"
                                onClick={onCancel}>
                                {closeButtonCaption}
                            </NewButton>
                        )}
                    </div>
                </div>
            </div>
        </NewModal>
    );
}
